import { Address, AddressSource } from "../enums/checkoutShipping";
import { customerApi } from "./customer";
import customerSlice from "./customerSlice";
import { onErrorHandler } from "./handlers";

const setCustomer = (response) => {
    return async (dispatch: any) => {
        dispatch(customerSlice.actions.customer({'customer': response}));
    }
}

const addAddress = ({customer, addressType, addressData, setDefaultAddress = false, loqateInformation = '', setVAT = false, setCustomerCompanyName = false, addressSource = AddressSource.WEB, isValidated = true}) => {
    return async (dispatch) => {
        try {
            const payload = {
                customerId: customer?.id,
                addressType,
                source: addressSource,
                address: {
                    ...addressData,
                    ...(addressData?.custom?.fields),
                    loqateInformation,
                },
                isValidated
            }

            delete payload.address.custom;
            
            if((!customer?.defaultShippingAddressIdMyAccount || setDefaultAddress) && addressType.includes(Address.SHIPPING)) payload['setDefaultShip'] = true
            if((!customer?.defaultBillingAddressIdMyAccount  || setDefaultAddress) && addressType.includes(Address.BILLING)) payload['setDefaultBill'] = true
            
            if(setVAT) payload['setVAT'] = true
            if(setCustomerCompanyName) payload['setCustomerCompanyName'] = true
            
            const res: any = await dispatch(customerApi.endpoints.createCustomerAddress.initiate(payload));
            if(res.error) {
                throw res.error;
            } else {
                return res.data;
            }
        }
        catch(error) {
            dispatch(onErrorHandler({operation: 'customerActions.addAddress(): Creating new customer address', err: JSON.stringify(error), errMsg: 'Error: while adding customer address', api: `customerActions.addAddress()`}));  
            throw error;
        }
    }
}

const editAddress = ({customer, addressId, addressType, addressData, setDefaultAddress = false, loqateInformation = '',  setVAT = false, setCustomerCompanyName = false, addressSource = AddressSource.WEB, isValidated = true}) => {
    return async (dispatch) => {
        try {
            const payload = {
                customerId: customer?.id,
                addressId,
                addressType,
                source: addressSource,
                address: {
                    ...addressData,
                    ...(addressData?.custom?.fields),
                    loqateInformation,
                },
                isValidated
            }
            delete payload.address.custom;
            if(setDefaultAddress && addressType === Address.SHIPPING) payload['setDefaultShip'] = true
            if(setDefaultAddress && addressType === Address.BILLING) payload['setDefaultBill'] = true
            if(setVAT) payload['setVAT'] = true
            if(setCustomerCompanyName) payload['setCustomerCompanyName'] = true
            const res: any = await dispatch(customerApi.endpoints.editCustomerAddress.initiate(payload));
            if(res.error) {
                throw res.error;
            } else {
                return res.data.data;
            }
        }
        catch(error) {
            dispatch(onErrorHandler({operation: 'customerActions.editAddress(): Editing customer address', err: JSON.stringify(error), errMsg: 'Error: while editing customer address', api: `customerActions.editAddress()`}));  
            throw error;
        }
    }
}

const customerActions = {
    setCustomer,
    addAddress,
    editAddress,
};

export default customerActions;
